import bStrg, { parsedToken } from "../storageHelper";
import { apiService } from "../apiService";
import urlConfig from "../../../config/domain";
import { IConvertPos, ICancelNrmTrd, IOFSReq, IMFCancel } from "../../types/components/orderBook/obTypes";
import { appIdKey, jwtToken } from "../../types/genericTypes";

const pToken: jwtToken | null = parsedToken(),
	userID = pToken ? pToken.username : null,
	appInfo: appIdKey = bStrg("appInfo");

//Show order book for a client in equity
export const AObEqReq = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.eq + userID + "/v1",
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//get order logs specific to order

export const AEqGetOrderLogs = (callback: CallableFunction, nOID: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.eqOrderLog + userID + "?nOID=" + nOID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
//get trade logs specific to user or orderid
export const AEqGetTradeBk = (callback: CallableFunction, nOID?: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.eqtradeBook + "/" + userID + (nOID ? "?nOID=" + nOID : ""),
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//get order details
export const AEqGetOrderDet = (callback: CallableFunction, nOID: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				// order/details/1111?nOID=111

				url: urlConfig.orderBook.eqOrderLog + userID + "?nOID=" + nOID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//cancel normal trade
export const AEqCancelNrmTrd = (callback: CallableFunction, cancelBody: ICancelNrmTrd) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				// order/details/1111?nOID=111
				url: urlConfig.orderBook.eqCancelNrmOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: cancelBody
			},
			callback
		);
	}
};

//cancel amo eq trade
export const AEqCancelAmoTrd = (callback: CallableFunction, cancelBody: ICancelNrmTrd) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				// order/details/1111?nOID=111

				url: urlConfig.orderBook.eqCancelAmoOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: cancelBody
			},
			callback
		);
	}
};

//cancel sip eq trade
export const AEqCancelSIPOrd = (callback: CallableFunction, sSNo: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				// order/details/1111?nOID=111

				url: urlConfig.orderBook.eqCancelSIPOrd,
				method: "PUT",
				authType: "authtoken",
				body: {
					request: {
						requestType: "U",
						msgID: "",
						data: {
							sSNo: sSNo
						},
						appID: appInfo.appid,
						session: "",
						formFactor: appInfo.ff
					}
				}
			},
			callback
		);
	}
};
//convert position api for equity
export const AEqConvertPos = (callback: CallableFunction, convertBody: IConvertPos) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				// order/details/1111?nOID=111

				url: urlConfig.orderBook.eqConvertPos + userID,
				method: "PUT",
				authType: "authtoken",
				body: convertBody
			},
			callback
		);
	}
};

// Shows order history for a client in equity
export const AObEqHistReq = (callback: CallableFunction, fromDate: string, toDate: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.eqHistory + userID + "?sDt=" + fromDate + "&eDt=" + toDate,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
// Shows SIP orders for a client in equity
export const AObEqSIP = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.eqSip,
				method: "POST",
				authType: "authtoken",
				body: {
					request: {
						requestType: "U",
						msgID: "",
						data: {},
						appID: appInfo.appid,
						session: "",
						formFactor: appInfo.ff
					}
				}
			},
			callback
		);
	}
};

//commodity orderbook
export const AObCommReq = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "EQ") {
		apiService(
			{
				url: urlConfig.orderBook.commodity + userID + "?rTyp=COMFNO",
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//get order logs specific to order
export const ACommGetOrderLogs = (callback: CallableFunction, oID: string) => {
	if (pToken && pToken.accType === "CO") {
		apiService(
			{
				url: urlConfig.orderBook.commOrderLog + userID + "?oID=" + oID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
//get trade logs specific to user or orderid
export const ACommGetTradeBk = (callback: CallableFunction, nOID?: string) => {
	if (pToken && pToken.accType === "CO") {
		apiService(
			{
				url: urlConfig.orderBook.commtradeBook + userID + (nOID ? "?nOID=" + nOID : ""),
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
// Shows order history for a client in commodity
export const AObCommHist = (callback: CallableFunction, fromDate: string, toDate: string) => {
	if (pToken && pToken.accType !== "EQ") {
		apiService(
			{
				url: urlConfig.orderBook.commodityHist + userID + "?sDt=" + fromDate + "&eDt=" + toDate,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
// commodity cancel normal trade
export const ACommCancelNrmTrd = (callback: CallableFunction, cancelBody: ICancelNrmTrd) => {
	if (pToken && pToken.accType !== "EQ") {
		apiService(
			{
				// order/details/1111?nOID=111
				url: urlConfig.orderBook.commCancelNrmOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: cancelBody
			},
			callback
		);
	}
};

//commodity cancel amo eq trade
export const ACommCancelAmoTrd = (callback: CallableFunction, cancelBody: ICancelNrmTrd) => {
	if (pToken && pToken.accType !== "EQ") {
		apiService(
			{
				// order/details/1111?nOID=111

				url: urlConfig.orderBook.commCancelAmoOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: cancelBody
			},
			callback
		);
	}
};

// convert position api for commodity
export const ACommConvertPos = (callback: CallableFunction, convertBody: IConvertPos) => {
	if (pToken && pToken.accType !== "EQ") {
		apiService(
			{
				// order/details/1111?nOID=111
				url: urlConfig.orderBook.commConvertPos + userID,
				method: "PUT",
				authType: "authtoken",
				body: convertBody
			},
			callback
		);
	}
};

//mutual fund orderbook
export const AObMfReq = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.mf + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
export const AObMfHist = (callback: CallableFunction, fromDate: string, toDate: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.mf + userID + "?frDt=" + fromDate + "&toDt=" + toDate,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
///order/sip/{userId}

export const AObMfSip = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.mfSip + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

export const AObMfSipTrsHist = (callback: CallableFunction, sipRegNo: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.mfSip + userID + "/child?sipNo=" + sipRegNo,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//cancel normal trade
export const AMfCancelNrmTrd = (callback: CallableFunction, cancelBody: IMFCancel) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.mfCancelNrmOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: cancelBody
			},
			callback
		);
	}
};

//cancelmf holding trade
export const AMfCancelHoldTrd = (callback: CallableFunction, cancelBody: IMFCancel) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.mfCancelHoldOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: cancelBody
			},
			callback
		);
	}
};

//cancel IPO  trade
export const AIpoCancelTrd = (callback: CallableFunction, ordID: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.ipoCancelOrd + userID,
				method: "PUT",
				authType: "authtoken",
				body: {
					ordID: ordID
				}
			},
			callback
		);
	}
};

export const AObIPO = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.ipo + "?clientId=" + userID,
				method: "GET",
				authType: "authtoken",
				appidkey: urlConfig.appidkey
			},
			callback
		);
	}
};
//ofs orderbook

export const AObOFS = (callback: CallableFunction, OFSReq: IOFSReq) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.ofs,
				method: "POST",
				authType: "authtoken",
				body: {
					request: {
						requestType: "U",
						msgID: "",
						data: OFSReq,
						appID: appInfo.appid,
						session: "",
						formFactor: appInfo.ff
					}
				}
			},
			callback
		);
	}
};

export const AObNCD = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.ncd,
				method: "POST",
				authType: "authtoken",
				body: {
					request: {
						requestType: "U",
						msgID: "",
						data: {},
						appID: appInfo.appid,
						session: "",
						formFactor: appInfo.ff
					}
				}
			},
			callback
		);
	}
};

export const AObNFO = (callback: CallableFunction, fromDate: string, toDate: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderBook.nfo + userID + "?frDt=" + fromDate + "&toDt=" + toDate,
				method: "GET",
				authType: "authtoken",
				appidkey: urlConfig.appidkey
			},
			callback
		);
	}
};
export default AObEqReq;
